import React from "react";

import LegalDocument from "./LegalDocument";
import { CONTACT } from "../data/content";

const SECTIONS = [
  {
    heading: "Introduction",
    body: "At New Age Services, we are dedicated to protecting your personal information and ensuring transparency about how we collect, use, and share your data.",
  },
  {
    heading: "Information We Collect",
    list: [
      "Personal details such as your name, phone number, and email address.",
      "Information submitted through contact forms or service inquiries.",
      "Technical data like IP address, browser type, and interaction logs.",
    ],
  },
  {
    heading: "Use of Information",
    list: [
      "To provide and improve our services.",
      "To respond to inquiries and provide customer support.",
      "To communicate updates, newsletters, and offers (with consent).",
      "To comply with legal obligations.",
    ],
  },
  {
    heading: "Data Sharing",
    body: "We do not sell your personal data. We may share data with trusted third-party partners solely to perform services on our behalf, under confidentiality agreements.",
  },
  {
    heading: "Cookies",
    body: "Our website may use cookies to enhance your browsing experience and collect usage data. You can control cookie settings through your browser.",
  },
  {
    heading: "Data Security",
    body: "We implement appropriate technical and organizational safeguards to protect your information against unauthorized access, alteration, disclosure, or destruction.",
  },
  {
    heading: "Your Rights",
    list: [
      "Request access to your personal data.",
      "Correct or update your personal details.",
      "Request deletion of your data (subject to legal obligations).",
    ],
  },
  {
    heading: "Changes to This Policy",
    body: "We may update our Privacy Policy from time to time. Any major changes will be communicated through our website.",
  },
];

function PrivacyPolicy() {
  return (
    <LegalDocument
      id="PrivacyPolicy"
      title="Privacy Policy"
      subtitle="Last updated: April 18, 2025"
      sections={SECTIONS}
    >
      {/* The only part not expressible as section data: it carries a link. */}
      <section>
        <h5>Contact Information</h5>
        <div>
          <p>
            If you have questions or concerns about our Privacy Policy, please contact us at:{" "}
            <strong>
              <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            </strong>
          </p>
        </div>
      </section>
    </LegalDocument>
  );
}

export default PrivacyPolicy;
